module.exports = __webpack_public_path__ + "a7d8273945592a12e31f974077538631.png";